import Marquee from 'react-fast-marquee';
import { CLIENT_LOGOS } from '../data/content';
import { MaskedRevealOnView, FadeUp } from './motion/Reveal';

const ClientWall = () => {
    return (
        <section data-testid="client-wall" className="bg-[#F4F5F6] text-[#0A0A0B] py-24 md:py-32 border-t border-[#0A0A0B]/10">
            <div className="mx-auto max-w-[1500px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-6 mb-14">
                    <div className="col-span-12 md:col-span-4">
                        <span className="overline text-[#FF3B00]">Partners · Trust</span>
                    </div>
                    <div className="col-span-12 md:col-span-8">
                        <MaskedRevealOnView
                            className="h-display text-[9vw] md:text-[5.4vw] leading-[0.9]"
                            lines={['Trusted by India\'s', 'engineering leaders.']}
                        />
                        <FadeUp delay={0.15}>
                            <p className="mt-6 max-w-2xl text-[#0A0A0B]/70 text-base md:text-lg leading-relaxed">
                                From automotive tier-1s to fastener majors, our bright bars ship into the country's most exacting supply chains.
                            </p>
                        </FadeUp>
                    </div>
                </div>
            </div>

            {/* Row 1 – left */}
            <div className="marquee-wrap border-y border-[#0A0A0B]/15 py-8">
                <Marquee gradient={false} speed={35} pauseOnHover>
                    {CLIENT_LOGOS.map((c, i) => (
                        <LogoBadge key={`a-${i}`} name={c.name} sub={c.sub} />
                    ))}
                </Marquee>
            </div>

            {/* Row 2 – right (reverse) */}
            <div className="marquee-wrap border-b border-[#0A0A0B]/15 py-8">
                <Marquee gradient={false} speed={30} direction="right" pauseOnHover>
                    {[...CLIENT_LOGOS].reverse().map((c, i) => (
                        <LogoBadge key={`b-${i}`} name={c.name} sub={c.sub} variant="outline" />
                    ))}
                </Marquee>
            </div>

            <div className="mx-auto max-w-[1500px] px-6 md:px-10 mt-10">
                <p className="overline text-[#0A0A0B]/40">
                    · Logos represent industries and reference customers. Actual client roster available on NDA request.
                </p>
            </div>
        </section>
    );
};

const LogoBadge = ({ name, sub, variant }) => (
    <div className="mx-8 md:mx-14 flex items-baseline gap-3 group">
        <span
            className={`h-display text-3xl md:text-5xl transition-colors ${
                variant === 'outline'
                    ? 'text-transparent'
                    : 'text-[#0A0A0B]/85 group-hover:text-[#FF3B00]'
            }`}
            style={variant === 'outline' ? { WebkitTextStroke: '1px rgba(10,10,11,0.75)' } : {}}
        >
            {name}
        </span>
        {sub && (
            <span className="overline text-[#0A0A0B]/50 hidden md:inline">{sub}</span>
        )}
        <span className="text-[#FF3B00] text-2xl md:text-3xl">✱</span>
    </div>
);

export default ClientWall;
